import React from "react";
import Image from "next/image";
import PlutoLogo from "../PlutoLogo";
import { FrameIntegration } from "@/types/types";
import Button from "../Button";
import Spinner from "../Spinner";
import Link from "next/link";

const formatOptionName = (id: string) => {
  if (!id) return null;
  return id?.replace(/-/g, " ")?.replace(/\b\w/g, (char) => char.toUpperCase());
};

function formatDescription(description) {
  const words = description.split(" ");

  // If more than 3 words, insert a newline after the third word
  if (words.length > 3) {
    words.splice(3, 0, "\n");
  }

  // Join the words back into a string
  return words.join(" ");
}

const IntegrationOptionsGrid: React.FC<{
  frameIntegrations?: FrameIntegration[];
  handleSelect: (id: string) => void;
  currentOption?: string;
  isLoading?: boolean;
}> = ({ frameIntegrations, currentOption, handleSelect, isLoading }) => {
  if (!frameIntegrations) return null;

  return (
    <div className="flex flex-col w-full">
      <p className="mt-6">
        Please select an example below to walk through the Frame experience.
      </p>
      <div className="grid grid-cols-2 md:flex  md:flex-row md:flex-wrap gap-4  md:gap-4 w-full mt-4 mb-8">
        {frameIntegrations?.map((example, index) => {
          return (
            <Button
              key={index}
              // className={className}
              className={`whitespace-pre-wrap flex flex-col !py-4 !text-sm place-content-center !h-full
                md:flex-row md:items-center md:!py-3 md:!px-3
                
                ${isLoading ? "" : "cursor-pointer"}`}
              accent={true}
              selected={currentOption === example.id}
              disabled={example.disabled}
              onClick={() => {
                if (!example.disabled && !isLoading) {
                  handleSelect(example.id);
                }
              }}
            >
              {(example.id as any) === "pluto-pseudo-bank" ? (
                <Image
                  height={100}
                  width={100}
                  className="h-7 w-7 md:h-[22px] md:w-[22px]"
                  src={"/your-app.svg"}
                  alt={example.id}
                />
              ) : example?.src ? (
                <Image
                  height={100}
                  width={100}
                  className="h-7 w-7 md:h-[22px] md:w-[22px]"
                  src={example?.src}
                  alt={example.id}
                />
              ) : (
                <PlutoLogo className="!h-10 !w-10 p-1 mb-2" />
              )}
              <span className="md:hidden">{example.title}</span>
              <span className="hidden md:block">{example.title}</span>
              {example.disabled && (
                <div className="absolute rounded inset-0 bg-black/5 dark:bg-black/50 flex items-center justify-center text-white ">
                  {/* <span className="-rotate-12 inline-flex items-center rounded-full bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                    Coming Soon
                  </span> */}
                  <span className="-rotate-3 inline-flex items-center rounded-full bg-green-500/80 px-1 py-0.5 text-xs  text-white ring-1 ring-inset ring-green-600">
                    Coming Soon
                  </span>
                </div>
              )}
            </Button>
          );
        })}
        <Link href="/guides/using-the-javascript-sdk">
          <Button
            className="whitespace-pre-wrap flex flex-col !py-4 !text-sm place-content-center !h-full
              md:flex-row md:items-center md:!py-3 md:!px-3"
            accent={true}
          >
            <PlutoLogo className="!h-4 !w-4" />
            <span className="md:hidden">Prove Any Source via API</span>
            <span className="hidden md:block">Prove Any Source via API</span>
          </Button>
        </Link>
      </div>
      {currentOption === "pluto-pseudo-bank" && (
        <p className="text-sm text-gray-500 italic">
          (The pseudo bank is a demo and works with any username and password,
          it is not a real bank)
        </p>
      )}
    </div>
  );
};

export default IntegrationOptionsGrid;
